import React from 'react';
import { Layout, LegacyCard, Page } from '@shopify/polaris';
import { Navigate } from 'react-router';
import useAuth from '../hooks/authentication/useAuth';

const LoginLandingPage: React.FC = () => {
    const auth = useAuth();

    return (
        <>
            {!auth.isLoggedIn ? (
                <Page narrowWidth>
                    <Layout>
                        <Layout.Section>
                            <LegacyCard title={'You must be logged in to use this site.'} sectioned></LegacyCard>
                        </Layout.Section>
                    </Layout>
                </Page>
            ) : (
                <Navigate to={'/'} replace />
            )}
        </>
    );
};

export default LoginLandingPage;
